/*
 * ---------------------------------------------------------------------
 * import modules
 * ---------------------------------------------------------------------
 */
import React from 'react';

import {
    IconButton,
} from "@material-ui/core";

import MenuIcon from '@material-ui/icons/Menu';

/*
 * ---------------------------------------------------------------------
 * class MobileMenuButton
 * ---------------------------------------------------------------------
 */
class MobileMenuButton extends React.Component {

    componentDidMount() {
        this.clickMenu = this.clickMenu.bind(this);
    }

    clickMenu() {
        this.props.onClick();
    }

    render() {
        return (<React.Fragment>
                    <IconButton color="primary" className="mobile-nav-button" edge="start" aria-label="open menu" onClick={() => this.clickMenu()}>
                        <MenuIcon />
                    </IconButton>
            </React.Fragment>);
    }

}
/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default MobileMenuButton;
